
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Home' }
  ];

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/301b91c9adaca0684fe24f931e418917/555ed6a9fc9e70bc6df8fb3fee5626b3.jpeg"
              alt="Redeeming Power Ministry Logo"
              className="h-12 w-12 object-contain"
            />
            <div className="text-xl font-bold text-amber-600" style={{fontFamily: '"Pacifico", serif'}}>
              Redeeming Power Ministry
            </div>
          </Link>

          {/* Desktop Navigation - Hidden since only Home remains */}
          <div className="hidden md:flex items-center space-x-8">
            {/* Navigation removed as requested */}
          </div>

          {/* Mobile Menu Button - Hidden since only Home remains */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 cursor-pointer hidden"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </div>
          </button>
        </div>

        {/* Mobile Navigation - Hidden */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100 hidden">
            <div className="flex flex-col space-y-4 pt-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`text-sm font-medium transition-colors cursor-pointer ${
                    location.pathname === item.path
                      ? 'text-amber-600'
                      : 'text-gray-700 hover:text-amber-600'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
